import React, { useState, useCallback, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import CommonComponentForQuestionsAndOption from '../Common/FeedbackGridRowForEmployer';
import 'react-toastify/dist/ReactToastify.css';
import '../../assets/css/styles.css';
import '../../assets/css/login.css';

var Modal = require('react-bootstrap-modal');
const axios = require('axios').default;
var config = require('../../config/config.json');

export default function EmployerFeedback(props) {
  document.title = props.title
  const navigate = useNavigate();
  let gridCount = 0;
  var retrievedUserDetailsObject = JSON.parse(localStorage.getItem('userEmployerDetailsLog'));
  const [modelPopupStatus, setModelPopupStatus] = useState(false);
  const [componentLodignState, setComponentLodignState] = useState(false);
  const [userLoginDetails, setLoginDetailsValue] = useState(retrievedUserDetailsObject);
  const [allQuestionsArray, setQuestionsArray] = useState([]);
  const [allEmployerAnswersArray, setEmployerAnswersArray] = useState([]);

  const [allEmployerOtherAnswersArray, setEmployerOtherAnswersArray] = useState([]);
  const [allEmployerOtherTextBoxStaticQuestion, setEmployerOtherTextBoxStaticQuestion] = useState(false);

  useEffect(() => {
    getAllQuestions();
  }, []);


  function onSubmitAlumniFeedbackClick() {

    let getQuestionsID = [];
    allQuestionsArray.map(function (questions, index) {
      if (questions.mafq_question_for_objective_or_descriptive == '0' && questions.mafq_appear_other_textbox == '0') {
        getQuestionsID.push(questions.mafq_auto_id)
      }
    })

    let getAnswerArrayWithoutDiscriptiveCount = 0;
    allEmployerAnswersArray.map((questions, index) => {
      if (questions.answer != "") {
        getAnswerArrayWithoutDiscriptiveCount += 1;
      }
    })

    if (getAnswerArrayWithoutDiscriptiveCount == getQuestionsID.length) {
      let Obj = {};
      Obj = {
        question_id: "76",
        answer: "",
        description: allEmployerOtherAnswersArray.toString()
      }
      allEmployerAnswersArray.push(Obj)
      setEmployerAnswersArray(allEmployerAnswersArray);

      axios.post(config.API_URL + 'submitEmployerFeedback', {
        ragisterUserId: userLoginDetails.alr_auto_id,
        answersArray: allEmployerAnswersArray
      }, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
      }).then(function (response) {
        if (response.data.status.status == 1) {
          toast(response.data.status.message);
          // setModelPopupStatus(true);
          localStorage.removeItem("userEmployerDetailsLog");
          localStorage.removeItem("isAuthenticated");
          localStorage.clear();
          navigate('/ThankYou');
        }
      }).catch(function (error) {
        toast(error);
      });
    } else {
      getQuestionsID.map((questions, index) => {
        let checkValidation = allEmployerAnswersArray.find(o => o.question_id === questions);
        if (!checkValidation) {
          var element = document.getElementById("studentInfra" + questions);
          element.classList.add("error");
        }
        console.log("checkValidation", checkValidation);
      });
      toast("All questions are compulsory.");
    }
  }

  function getAllQuestions() {
    setComponentLodignState(true);
    axios.post(config.API_URL + 'getEmployerFeedbackQuestion', {
      userId: userLoginDetails.LoginUserId
    }, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
    }).then(function (response) {
      if (response.data.status.status == 1) {
        console.log("getEmployerFeedbackQuestion", response.data.data);
        if (response.data.data != null && response.data.data != "") {
          setQuestionsArray(response.data.data);
        } else {
          setQuestionsArray([]);
        }
        setComponentLodignState(false);
      }
    }).catch(function (error) {
      toast(error);
      setComponentLodignState(false);
    });
  }


  const onItemClick = useCallback(event => {

    let Obj = {};
    if (event.target.getAttribute('q_type') !== "Descriptive") {
      Obj = {
        question_id: event.target.getAttribute('questionid'),
        answer: event.target.getAttribute('questionanswer'),
        description: ""
      }
    } else {
      Obj = {
        question_id: event.target.getAttribute('questionid'),
        answer: "",
        description: event.target.value
      }
    }

    if (allEmployerAnswersArray.length == 0) {
      allEmployerAnswersArray.push(Obj)
      setEmployerAnswersArray(allEmployerAnswersArray);
    } else {
      let checkNewPushBit = true;
      allEmployerAnswersArray.find((o, i) => {
        if (o.question_id === event.target.getAttribute('questionid')) {
          allEmployerAnswersArray[i] = Obj;
          checkNewPushBit = false;
        }
      });
      if (checkNewPushBit) {
        allEmployerAnswersArray.push(Obj)
      }
      setEmployerAnswersArray(allEmployerAnswersArray);
    }
    var element = document.getElementById("studentInfra" + event.target.getAttribute('questionid'));
    element.classList.remove("error");

    console.log("allEmployerAnswersArray", allEmployerAnswersArray);
    // var target = event.target;
    // var parent = target.parentElement.parentElement;//parent of "target"
  }, [allQuestionsArray]);


  const onStaticQuestionClick = useCallback(event => {
    if (event.target.checked) {
      allEmployerOtherAnswersArray.push(event.target.value)
      setEmployerOtherAnswersArray(allEmployerOtherAnswersArray);
      if (event.target.value == "Any other") {
        setEmployerOtherTextBoxStaticQuestion(true);
      }
    } else {
      const index = allEmployerOtherAnswersArray.indexOf(event.target.value);
      if (index > -1) {
        allEmployerOtherAnswersArray.splice(index, 1);
      }
      setEmployerOtherAnswersArray(allEmployerOtherAnswersArray);
      if (event.target.value == "Any other") {
        setEmployerOtherTextBoxStaticQuestion(false);
      }
    }
    console.log("allEmployerOtherAnswersArray", allEmployerOtherAnswersArray.toString());
  }, [allEmployerOtherAnswersArray]);


  function clickOnLogOut() {
    localStorage.removeItem("userEmployerDetailsLog");
    localStorage.removeItem("isAuthenticated");
    localStorage.clear();
    navigate('/Employer');
  }

  let saveAndClose = () => {
    setModelPopupStatus(false);
    navigate('/EmployerDashboard');
  }

  const LogoURL = require(`../../assets/images/${config.logoUrl}`).default;

  return (

    <div className="index-cover">
      <div className="container main-container">
        <section className='section-header' >
          <div className='row'><div className="col-md-12" >
            <div className='logout-strip'>
              <div className='link-holder'>
                <a className="btn-link" type="button">Welcome {userLoginDetails.userName}&nbsp;</a>
                <span className='line-divider'></span>
                <a className="btn-link" type="button" onClick={clickOnLogOut}>Logout</a>
              </div>
            </div>
            <div className="college-name" ><img src={LogoURL} className='logo-college' alt='' />{config.collegeName} </div>
            <div className='feedback-title' >Feedback on Academic Performance and Ambiance</div>
          </div>
          </div>
        </section>

        {componentLodignState == true ?
          <div class="loader-bg">
            <h3>Please Wait...</h3>
            <div class="loader">
              <span></span>
            </div>
          </div>
          :
          <section className='section-survey section-surveyStudentInfrastructure'>
            <div className="row">
              <div className="col-md-12">
                <div className='info info-white'>Fields marked with <em>*</em> are mandatory</div>
                <div class='info info-white'>Please use this form to provide your feedback. For the questions requiring you to rank the student kindly rate her performance on a scale of 1 to 5, with 1 being unacceptable, and 5 being exceptional. Your responses will be kept confidential.</div>
                <div className='questionnnaire-wrapper'>
                  <div className='grid-row row-header sticky'>
                    <div className='column col-srno'>#</div>
                    <div className='column col-question'><div className='column-content'> &nbsp; </div></div>
                    <div className='column col-grade'>1</div>
                    <div className='column col-grade'>2</div>
                    <div className='column col-grade'>3</div>
                    <div className='column col-grade'>4</div>
                    <div className='column col-grade'>5</div>
                  </div>
                  {
                    allQuestionsArray.length >= 1 ?
                      allQuestionsArray.map((questions, index) => (
                        (questions.mafq_question_for_objective_or_descriptive == '0' ?
                          questions.mafq_appear_other_textbox == '0' ?
                            <CommonComponentForQuestionsAndOption term={questions} onItemClick={onItemClick} srNo={gridCount = gridCount + 1} />
                            : null
                          : null
                        )
                      ))
                      : null
                  }

                  {
                    allQuestionsArray.length >= 1 ?
                      allQuestionsArray.map((questions, index) => (
                        questions.mafq_question_for_objective_or_descriptive == '1' ?
                          <div className='grid-row grid-row-seperate' id={'studentInfra' + questions.mafq_auto_id}>
                            <div className='column col-srno'>{gridCount = gridCount + 1}</div>
                            <div className='column col-fullWidthQuestion'><div className='column-content'>{questions.mafq_question} <br />
                              <textarea id="textarea1" className='textarea' rows="2" placeholder="Remarks, if any" onChange={onItemClick} q_type="Descriptive" questionid={questions.mafq_auto_id}></textarea>
                            </div></div>
                          </div>
                          : null
                      ))
                      : null
                  }

                  <div class='grid-row grid-row-seperate'>
                    <div class='column col-srno'>{allQuestionsArray.length + 1}.</div>
                    <div class='column col-question'>
                      <div class='column-content'>Reasons for employing our students in your  organization. Select and rank three most preferred Skills or qualities of our students from those listed
                      </div>
                    </div>
                    <div class='column col-5-gradeCombined'>
                      <div class='column-content'>
                        <label class='col-md-12'><input type="checkbox" style={{ width: 'auto' }} value="Communication skills" onChange={onStaticQuestionClick} /> Communication skills</label>
                        <label class='col-md-12'><input type="checkbox" style={{ width: 'auto' }} value="Subject matter knowledge" onChange={onStaticQuestionClick} /> Subject matter knowledge</label><br />
                        <label class='col-md-12'><input type="checkbox" style={{ width: 'auto' }} value="Research skills" onChange={onStaticQuestionClick} /> Research skills</label><br />
                        <label class='col-md-12'><input type="checkbox" style={{ width: 'auto' }} value="Enthusiasm and motivation" onChange={onStaticQuestionClick} /> Enthusiasm and motivation</label><br />
                        <label class='col-md-12'><input type="checkbox" style={{ width: 'auto' }} value="ICT and Technology proficiency" onChange={onStaticQuestionClick} /> ICT and Technology proficiency </label> <br />
                        <label class='col-md-12'><input type="checkbox" style={{ width: 'auto' }} value="Team spirit" onChange={onStaticQuestionClick} /> Team spirit</label><br />
                        <label class='col-md-12'><input type="checkbox" style={{ width: 'auto' }} value="Any other" onChange={onStaticQuestionClick} /> Any other, please specify </label>
                        {allEmployerOtherTextBoxStaticQuestion == true ?
                          <input type='text' class='form-control' placeholder="please specify" />
                          : null}
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div className='col-md-12'>
                <button type="button" className="btn btn-primary btn-submitForm btn-block" onClick={onSubmitAlumniFeedbackClick}>Submit</button>
              </div>
            </div>
          </section>
        }

        <section className='section-footer'>
          <div className='row'><div className='col-md-12'><div className='footer col-md-6'>{config.collegeName}, Feedback System {config.version}</div>
            <div className='footer col-md-6' style={{ textAlign: 'right' }}>{config.PoweredBy}</div>
          </div></div>
        </section>
      </div>
      <ToastContainer />
      <Modal
        show={modelPopupStatus}
        backdrop="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Body>
          <div className="font-robo">
            <div className="">
              <div className="card card-1 " style={{ boxShadow: 'none' }}>
                {/* <div className="logo-holder">
                  <div className="college-name" ><img src={LogoURL} className='logo-college' alt='' />{config.collegeName} </div>
                  <div className='feedback-title' >Feedback System</div>
                </div> */}
                <div className="card-body card-thankyou" style={{ padding: '5px 5px', textAlign: 'center' }}>
                  <center>
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                      <circle className="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1" />
                      <polyline className="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
                    </svg>
                  </center>
                  <div className='message-submitThankyou'>
                    <h3>Feedback submited successfully.<br />
                      Thank you for your valuable time.</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <center>
            <button className='btn btn-primary btn-submitForm' style={{ display: 'block' }} onClick={saveAndClose}>
              Back to Main Page
            </button>
          </center>
        </Modal.Footer>
      </Modal>
    </div>
  )
}